import __request__ from "routing/request";
export function deprecatedDeflector() {
  return __request__("GET", "/system/deflector", null, {}, {
    "Accept": ["application/json"]
  });
}
export function deprecatedCycle() {
  return __request__("POST", "/system/deflector/cycle", null, {}, {
    "Accept": []
  });
}
export function deflector(indexSetId) {
  return __request__("GET", `/system/deflector/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function cycle(indexSetId) {
  return __request__("POST", `/system/deflector/${indexSetId}/cycle`, null, {}, {
    "Accept": []
  });
}
